import { SOMETHING_WENT_WRONG } from "../helper/constants";

export function throwError(data, message = SOMETHING_WENT_WRONG) {
    if (data instanceof Error && data.cause) {
        throw data;
    }
    throw new Error(message, { cause: data });
}
